import clone from 'lodash.clonedeep';
import {
    ADD_AND_APPLY_FILTER,
    REMOVE_AND_APPLY_FILTER,
    CLEAR_FILTERS_BY_NAME,
    TOGGLE_FILTER_DISPLAY,
    ADD_APPLIED_FILTERS,
    TOGGLE_REQUEST_IN_FLIGHT,
    UPDATE_URI_REF,
} from '../actions/filterActions';
import { UPDATE_RELAY_VARIABLES } from '../actions/sharedRelayVariableActions';
import UriRefBuilder from 'dibs-generate-uriref';
import { getQueryParam, addCdnQueryParams } from '../utils/uriUtils';
import get from 'lodash.get';
let uriRefBuilder;
let initialVariables;

const initUriRefBuilder = () => {
    uriRefBuilder = new UriRefBuilder();
};

/**
 * Used for testing purposes.
 */
export function resetUriRefBuilder() {
    uriRefBuilder = null;
}

function getUriRef() {
    return addCdnQueryParams(uriRefBuilder.getUriRef());
}

const getPage = generatedUriRef => parseInt(getQueryParam(generatedUriRef, 'page'), 10) || 1;

const applyFilters = state => {
    const appliedFilters = clone(uriRefBuilder.getFilters()).filter(({ name }) => name !== 'page');
    // FINDING-12453 - remove page filter when applying new filter
    uriRefBuilder.removeFiltersByName('page');
    return {
        ...state,
        appliedFilters,
        generatedUriRef: getUriRef(),
    };
};

const initialState = {
    isClient: false,
    filtersShown: false,
    appliedFilters: [],
    generatedUriRef: null,
    page: 1,
    refetchInFlight: false,
};

function filterReducer(state = initialState, action) {
    const { type, payload } = action;
    if (!uriRefBuilder && state.isClient) {
        initUriRefBuilder();
    }

    // if a request is in flight, the state is temporarily locked until it completes :
    if (state.refetchInFlight && type !== TOGGLE_REQUEST_IN_FLIGHT) {
        return state;
    }

    switch (type) {
        case UPDATE_RELAY_VARIABLES:
            return { ...state, ...{ isClient: get(action, 'variables.isClient') } };

        case TOGGLE_REQUEST_IN_FLIGHT:
            return { ...state, ...{ refetchInFlight: payload } };

        case ADD_APPLIED_FILTERS: {
            initUriRefBuilder();
            initialVariables = payload;
            uriRefBuilder.addFilters(initialVariables);
            const generatedUriRef = getUriRef();
            return {
                ...state,
                generatedUriRef,
                page: getPage(generatedUriRef),
                appliedFilters: uriRefBuilder.getFilters(),
            };
        }

        case TOGGLE_FILTER_DISPLAY: {
            const filtersShown =
                typeof action.filtersShown === 'boolean'
                    ? action.filtersShown
                    : !state.filtersShown;
            return { ...state, filtersShown };
        }

        case ADD_AND_APPLY_FILTER:
            uriRefBuilder.addFilter(payload.filterName, payload.filterValue);
            return applyFilters(state, payload);

        case REMOVE_AND_APPLY_FILTER:
            uriRefBuilder.removeFilter(payload.filterName, payload.filterValue);
            return applyFilters(state, payload);

        case CLEAR_FILTERS_BY_NAME:
            uriRefBuilder.removeFiltersByName(payload);
            return {
                ...state,
                appliedFilters: clone(uriRefBuilder.getFilters()),
            };

        case UPDATE_URI_REF: {
            const newUriRef = payload ? addCdnQueryParams(payload) : getUriRef();
            return {
                ...state,
                appliedFilters: [],
                generatedUriRef: newUriRef,
                page: getPage(newUriRef),
            };
        }

        default:
            return state;
    }
}

export default filterReducer;
